export default "__VITE_ASSET__tE4fnw2M__"